import React, { useRef } from 'react';

import InputLabel from 'uiToolkitV1/InputLabel';
import { InputV2 } from 'uiToolkitV1/InputV2';
import { Tooltip } from 'uiToolkitV1/Tooltip';

import { useLocalState } from '../Details/useLocalState';
import { InputLabelTextWithInfoTooltip } from './ManualKRTracking';

export const OKRMetric = ({
  measureType = '',
  onChange = () => {},
  onValueChange = () => {},
  isReadOnly,
  showInfoTooltip = false,
  showTextTooltip = false,
  showLabel = true,
}) => {
  const ref = useRef();
  const [localMeasureType, setLocalMeasureType] = useLocalState(measureType);

  const onBlur = () => {
    onChange(localMeasureType);
  };

  const onKeyDown = (ev) => {
    if (ev.key === 'Enter') {
      ref?.current?.blur();
    }
  };

  const handleLocalValueChange = (ev) => {
    const { target } = ev;

    setLocalMeasureType(target.value);
    onValueChange(target.value);
  };

  const infoTooltip = showInfoTooltip ? <InputLabelTextWithInfoTooltip labelText="Metric" /> : 'Metric';

  const labelText = showLabel ? infoTooltip : '';

  return (
    <InputLabel
      labelText={labelText}
      containerProps={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        className: 'metric-select-label',
      }}
    >
      <Tooltip isDisabled={!showTextTooltip} label={localMeasureType}>
        <InputV2
          ref={ref}
          isReadOnly={isReadOnly}
          placeholder="Metric"
          isDashed
          value={localMeasureType}
          onChange={handleLocalValueChange}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
        />
      </Tooltip>
    </InputLabel>
  );
};
